export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
export const CDN_BASE_URL = process.env.REACT_APP_CDN_BASE_URL || 'https://fideprep.b-cdn.net';
export const PREMIUM_CDN_BASE_URL = (
  process.env.REACT_APP_PREMIUM_CDN_BASE_URL || 'https://fideprep-premium.b-cdn.net'
).replace(/\/+$/, '');
export const CDN_MOCK_URL = `${PREMIUM_CDN_BASE_URL}/mocks`;
export const FREE_BUNNY_CDN_URL = (process.env.REACT_APP_FREE_BUNNY_CDN_URL || 'https://fideprep.b-cdn.net').replace(
  /\/+$/,
  '',
);
export const BUNNY_CDN_URL = (process.env.REACT_APP_BUNNY_CDN_URL || 'https://fideprep-premium.b-cdn.net').replace(
  /\/+$/,
  '',
);
